(() => {
  setCountdownTimers();
  function setCountdownTimers() {
    const timersList = document.querySelectorAll(".countdown");
    if (timersList.length === 0) return;
    timersList.forEach((timer) => {
      const daysContainer = timer.querySelector(".countdown__number--days");
      const hoursContainer = timer.querySelector(".countdown__number--hours");
      const minutesContainer = timer.querySelector(
        ".countdown__number--minutes"
      );
      const secondsContainer = timer.querySelector(
        ".countdown__number--seconds"
      );

      /**
       * String in format YYYY/MM/DD HH:MM:SS
       * @type String
       * */
      const endDate = timer.dataset.endDate;

      /**
       * String in format DD:HH:MM:SS
       * @type String
       * */
      const timeInterval = timer.dataset.timeInterval;

      if (endDate !== "") {
        // Set the date we're counting down to
        const countDownDate = new Date(endDate).getTime();

        // Update the count down every 1 second
        const x = setInterval(function () {
          // Get today's date and time
          const now = new Date().getTime();

          // Find the distance between now and the count down date
          const distance = countDownDate - now;

          // Time calculations for days, hours, minutes and seconds
          const days = Math.floor(distance / (1000 * 60 * 60 * 24))
            .toString()
            .padStart(2, "0");
          const hours = Math.floor(
            (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
          )
            .toString()
            .padStart(2, "0");
          const minutes = Math.floor(
            (distance % (1000 * 60 * 60)) / (1000 * 60)
          )
            .toString()
            .padStart(2, "0");
          const seconds = Math.floor((distance % (1000 * 60)) / 1000)
            .toString()
            .padStart(2, "0");

          // Output the result
          daysContainer.innerHTML = days;
          hoursContainer.innerHTML = hours;
          minutesContainer.innerHTML = minutes;
          secondsContainer.innerHTML = seconds;

          // if countdown is over, hide the timer
          if (distance < 0) {
            clearInterval(x);
            timer.style.display = "none";
          }
        }, 1000);
      } else if (timeInterval !== "") {
        const timeIntervalArray = timeInterval.split(":");
        const fixedDays = parseInt(timeIntervalArray[0]) || 0;
        const fixedHours = parseInt(timeIntervalArray[1]) || 0;
        const fixedMinutes = parseInt(timeIntervalArray[2]) || 0;
        const fixedSeconds = parseInt(timeIntervalArray[3]) || 0;

        if (fixedHours > 23 || fixedMinutes > 59 || fixedSeconds > 59) {
          timer.innerHTML =
            '<p style="color: red"> ⚠️ Error: Intervalo de tiempo inválido</p>';
          return;
        }

        let days = fixedDays;
        let hours = fixedHours;
        let minutes = fixedMinutes;
        let seconds = fixedSeconds;
        setInterval(function () {
          if (seconds > 0) {
            seconds--;
          } else if (minutes > 0) {
            minutes--;
            seconds = 59;
          } else if (hours > 0) {
            hours--;
            minutes = 59;
            seconds = 59;
          } else if (days > 0) {
            days--;
            hours = 23;
            minutes = 59;
            seconds = 59;
          } else {
            days = fixedDays;
            hours = fixedHours;
            minutes = fixedMinutes;
            seconds = fixedSeconds;
          }

          daysContainer.innerHTML = days.toString().padStart(2, "0");
          hoursContainer.innerHTML = hours.toString().padStart(2, "0");
          minutesContainer.innerHTML = minutes.toString().padStart(2, "0");
          secondsContainer.innerHTML = seconds.toString().padStart(2, "0");
        }, 1000);
      }
    });
  }
})();
